import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  ResendConfirmationInstructionsMutation,
  ResendConfirmationInstructionsMutationVariables,
} from './__generated__/useResendConfirmationInstructions.graphql.ts';

const RESEND_CONFIRMATION_INSTRUCTIONS = gql`
  mutation ResendConfirmationInstructionsMutation(
    $input: resendConfirmationInstructionsInput!
  ) {
    resendConfirmationInstructions(input: $input) {
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  ResendConfirmationInstructionsMutation,
  ResendConfirmationInstructionsMutationVariables
>;

export const useResendConfirmationInstructions = () => {
  const [mutate] = useMutation(RESEND_CONFIRMATION_INSTRUCTIONS, {
    showErrorsWithSnackNotification: true,
  });
  return mutate;
};
